// ============================================================
// PEAKSTA ADVERTORIAL — SCRIPT.JS
// ============================================================

// ---- DATE UTILITIES ----
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const now = new Date();
const currentMonth = MONTHS[now.getMonth()];
const currentYear = now.getFullYear();
const tariffDate = new Date(now);
tariffDate.setDate(tariffDate.getDate() + 31);
const tariffMonth = MONTHS[tariffDate.getMonth()];
const tariffDay = tariffDate.getDate();

// ---- DYNAMIC COUNTERS (sessionStorage) ----
let bagsSold = parseInt(sessionStorage.getItem('bagsSold')) || 2847;
let readingCount = parseInt(sessionStorage.getItem('readingCount')) || 347;
let stockCount = parseInt(sessionStorage.getItem('stockCount')) || 23;

// ---- COUNTDOWN TIMER ----
let countdownEnd = parseInt(sessionStorage.getItem('countdownEnd'));
if (!countdownEnd || isNaN(countdownEnd)) {
  countdownEnd = Date.now() + 12 * 60 * 60 * 1000;
  sessionStorage.setItem('countdownEnd', countdownEnd);
}

function formatCountdown(ms) {
  if (ms <= 0) return '00:00:00';
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
}

// ---- UPDATE FUNCTIONS ----
function updateAllCounters() {
  // Bags sold
  const bagEls = document.querySelectorAll('.js-bags-sold');
  bagEls.forEach(el => el.textContent = bagsSold.toLocaleString());
  // Reading count
  const readEls = document.querySelectorAll('.js-reading-count');
  readEls.forEach(el => el.textContent = readingCount.toLocaleString());
  // Stock count
  const stockEls = document.querySelectorAll('.js-stock-count');
  stockEls.forEach(el => el.textContent = stockCount);
}

function updateCountdown() {
  const remaining = countdownEnd - Date.now();
  const str = formatCountdown(remaining);
  document.querySelectorAll('.js-countdown').forEach(el => el.textContent = str);
  if (remaining > 0) requestAnimationFrame(updateCountdown);
}

function scheduleBagIncrement() {
  const delay = Math.floor(Math.random() * 75000) + 15000;
  setTimeout(() => {
    bagsSold += Math.floor(Math.random() * 3) + 1;
    sessionStorage.setItem('bagsSold', bagsSold);
    updateAllCounters();
    scheduleBagIncrement();
  }, delay);
}

function scheduleReadingIncrement() {
  const delay = Math.floor(Math.random() * 37000) + 8000;
  setTimeout(() => {
    if (Math.random() < 0.15) {
      readingCount -= Math.floor(Math.random() * 2) + 1;
    } else {
      readingCount += Math.floor(Math.random() * 5) + 1;
    }
    readingCount = Math.max(readingCount, 300);
    sessionStorage.setItem('readingCount', readingCount);
    updateAllCounters();
    scheduleReadingIncrement();
  }, delay);
}

function scheduleStockDecrement() {
  const delay = Math.floor(Math.random() * 75000) + 45000;
  setTimeout(() => {
    if (stockCount > 3) {
      stockCount -= 1;
      sessionStorage.setItem('stockCount', stockCount);
      updateAllCounters();
    }
    scheduleStockDecrement();
  }, delay);
}

// ---- PURCHASE TOAST ----
const toastNames = [
  'Sarah from Texas', 'Linda from California', 'Karen from Florida',
  'Margaret from Ohio', 'Donna from Georgia', 'Patricia from Virginia',
  'Susan from Arizona', 'Nancy from Colorado', 'Janet from Oregon',
  'Carol from Michigan', 'Diane from New York', 'Sandra from Illinois',
  'Cynthia from Washington', 'Ruth from Pennsylvania', 'Barbara from Nevada',
  'Marie from Massachusetts', 'Helen from Tennessee', 'Deborah from Minnesota',
  'Laura from North Carolina', 'Emily from Wisconsin'
];

function showPurchaseToast() {
  const toast = document.getElementById('purchaseToast');
  if (!toast) return;
  const name = toastNames[Math.floor(Math.random() * toastNames.length)];
  const mins = Math.floor(Math.random() * 8) + 1;
  toast.querySelector('.toast-name').textContent = name;
  toast.querySelector('.toast-time').textContent = `${mins} minute${mins > 1 ? 's' : ''} ago`;
  toast.classList.add('visible');
  setTimeout(() => toast.classList.remove('visible'), 4500);
}

function schedulePurchaseToast() {
  const delay = Math.floor(Math.random() * 60000) + 30000;
  setTimeout(() => {
    showPurchaseToast();
    schedulePurchaseToast();
  }, delay);
}

// ---- FADE-IN ON SCROLL ----
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

// ---- STICKY BOTTOM CTA ----
function initStickyCta() {
  const stickyCta = document.getElementById('stickyCta');
  if (!stickyCta) return;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 500) {
      stickyCta.classList.add('visible');
    } else {
      stickyCta.classList.remove('visible');
    }
  }, { passive: true });
}

// ---- BAR CHART ANIMATION ----
function initBarChart() {
  const chartObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.bar-fill').forEach(bar => {
          const targetWidth = bar.style.width;
          bar.style.width = '0%';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => { bar.style.width = targetWidth; });
          });
        });
        chartObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  const chart = document.getElementById('destChart');
  if (chart) chartObserver.observe(chart);
}

// ---- SMOOTH SCROLL ANCHORS ----
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

// ---- FAQ ACCORDION ----
function initFAQ() {
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

// ---- COMPARISON TABLE AUTO-SCROLL (mobile) ----
function initTableAutoScroll() {
  if (window.innerWidth > 768) return;
  const wrapper = document.querySelector('.table-scroll-wrapper');
  if (!wrapper) return;
  const tableObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          wrapper.scrollTo({ left: wrapper.scrollWidth, behavior: 'smooth' });
          setTimeout(() => wrapper.scrollTo({ left: 0, behavior: 'smooth' }), 1200);
        }, 600);
        tableObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  tableObs.observe(wrapper);
}

// ---- FACEBOOK COMMENTS TOGGLE ----
function initFBComments() {
  const toggleBtn = document.getElementById('fbCommentsToggle');
  const hiddenComments = document.getElementById('fbCommentsHidden');
  if (!toggleBtn || !hiddenComments) return;
  toggleBtn.addEventListener('click', () => {
    hiddenComments.classList.toggle('fb-comments-expanded');
    toggleBtn.textContent = hiddenComments.classList.contains('fb-comments-expanded')
      ? 'Show fewer comments' : 'View more comments';
  });
}

// ---- INIT ON DOM READY ----
document.addEventListener('DOMContentLoaded', () => {
  // Observe fade sections
  document.querySelectorAll('.fade-section').forEach(el => observer.observe(el));

  // Dynamic dates
  document.querySelectorAll('.js-current-month').forEach(el => el.textContent = currentMonth);
  const heroDate = document.getElementById('heroDate');
  if (heroDate) heroDate.textContent = `${currentMonth} ${now.getDate()}, ${currentYear}`;
  const tariffEl = document.getElementById('tariffAlert');
  if (tariffEl) tariffEl.textContent = `${tariffMonth} ${tariffDay}`;

  // Init counters
  updateAllCounters();
  updateCountdown();
  scheduleBagIncrement();
  scheduleReadingIncrement();
  scheduleStockDecrement();

  // Init features
  initStickyCta();
  initBarChart();
  initSmoothScroll();
  initFAQ();
  initTableAutoScroll();
  initFBComments();

  // First purchase toast after 15-25 seconds
  setTimeout(() => {
    showPurchaseToast();
    schedulePurchaseToast();
  }, Math.floor(Math.random() * 10000) + 15000);
});
